import { RoutePath, ROUTES_PATH } from '@/shared/constants/routes';

export const getRoutePath = <
  T extends keyof RoutePath,
  U extends keyof RoutePath[T],
>(
  ...segments: [T, U]
): string => {
  const [first, second] = segments;
  const firstPart =
    ROUTES_PATH[first].INDEX === '/' ? '' : `/${ROUTES_PATH[first].INDEX}`;

  if (first === 'MAIN' && second === 'INDEX') {
    return '/';
  }

  if (second === 'INDEX') {
    return `${firstPart}/`;
  }

  return `${firstPart}/${ROUTES_PATH[first][second]}`;
};
